/**
 * Monthly gift pricing for the gifting UI (checkout totals + fee labels)
 */
import gg_fees from './gg_pricing.js';

const MONTHLY_BILLING_ADDON_RATE = 0.008;

function calculateMonthlyProcessingFeesCents(giftAmountCents, pmType) {
  const giftCents = Math.round(Number(giftAmountCents) || 0);
  let baseFeeCents = 0;

  if (pmType === 'CC') {
    baseFeeCents = Math.floor(
      giftCents * gg_fees.send_fees.cc_variable + gg_fees.send_fees.cc_fixed
    );
  } else if (pmType === 'ACH') {
    baseFeeCents = Math.floor(
      giftCents * gg_fees.send_fees.ach_variable + gg_fees.send_fees.ach_fixed
    );
  }

  const billingAddonCents = Math.floor(giftCents * MONTHLY_BILLING_ADDON_RATE);
  return baseFeeCents + billingAddonCents;
}

/** Gift amount in dollars string like "$100" → processing fee dollars for display */
export function calculateMonthlyProcessingFeeDollars(giftAmountStr, pmType) {
  const giftDollars = Number(String(giftAmountStr || '').replace(/^\$/, '')) || 0;
  const giftCents = Math.round(giftDollars * 100);
  const feeCents = calculateMonthlyProcessingFeesCents(giftCents, pmType);
  return feeCents / 100;
}

export function calculateMonthlyChargeDollars({
  giftAmountStr,
  pmType,
  chooseFeeValue = 0,
  acceptAdditionalCharges = true,
}) {
  const giftDollars = Number(String(giftAmountStr || '').replace(/^\$/, '')) || 0;
  const giftCents = Math.round(giftDollars * 100);
  const platformCents = Math.round(Number(chooseFeeValue) * 100) || 0;
  const processingCents = calculateMonthlyProcessingFeesCents(giftCents, pmType);
  const totalCents = acceptAdditionalCharges
    ? giftCents + processingCents + platformCents
    : giftCents + platformCents;
  return totalCents / 100;
}

/** Display rate string for send fees */
export function formatSendFeeRate(pmType, isMonthly = false) {
  const fees = gg_fees.send_fees;
  let variableRate = 0;
  let fixedCents = 0;

  if (pmType === 'CC') {
    variableRate = fees.cc_variable + (isMonthly ? MONTHLY_BILLING_ADDON_RATE : 0);
    fixedCents = fees.cc_fixed;
  } else if (pmType === 'ACH') {
    variableRate = fees.ach_variable + (isMonthly ? MONTHLY_BILLING_ADDON_RATE : 0);
    fixedCents = fees.ach_fixed;
  }

  const rateLabel = `${String((variableRate * 100).toFixed(1))}%`;
  return fixedCents === 0 ? rateLabel : `${rateLabel} +${fixedCents}¢`;
}

/** Category subtext for payment method dropdowns */
export function getSendFeeCategorySubtext(pmType, isMonthly = false) {
  return `${formatSendFeeRate(pmType, isMonthly)} Payment Processing Fee`;
}

/** Refresh fee subtext on an existing pm_get dropdown list */
export function updatePmListFeeSubtext(list, isMonthly = false) {
  if (!list || !list.length) {
    return list;
  }

  return list.map((category) => {
    if (category.category_header === 'Credit Cards') {
      return {
        ...category,
        category_subtext: getSendFeeCategorySubtext('CC', isMonthly),
      };
    }
    if (category.category_header === 'Bank Debits - ACH') {
      return {
        ...category,
        category_subtext: getSendFeeCategorySubtext('ACH', isMonthly),
      };
    }
    return category;
  });
}

export { MONTHLY_BILLING_ADDON_RATE };
